import { useSnackbar } from 'notistack';
import { useMutation, useQueryClient } from 'react-query';
import { QUERY_KEYS } from 'shared/constants';
import { useService } from 'shared/providers';
import { UpdateImportanceProps } from 'shared/service';
import { CustomerCommodity, ObjectTyped } from 'shared/types';

export function useUpdateImportance() {
  const { customerCommodityService } = useService();
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();

  const mutation = useMutation<CustomerCommodity[], Error, UpdateImportanceProps>(
    request => customerCommodityService.updateImportance(request),
    {
      onSuccess: data => {
        queryClient.setQueryData<CustomerCommodity[]>(QUERY_KEYS.customerCommodities, old => {
          if (old) {
            const updatedRowsMap = ObjectTyped.fromEntries(data.map(c => [c.id, c]));

            return old.map(grid => (updatedRowsMap[grid.id] ? updatedRowsMap[grid.id] : grid));
          }
          return [];
        });
        enqueueSnackbar('Customer importance was updated', { variant: 'success' });
      },
      onError: () => {
        enqueueSnackbar('There was a problem updating importance', { variant: 'error' });
      },
    }
  );

  return mutation;
}
